// extracted by mini-css-extract-plugin
export default {"app":"Layout_app__EIknj","main":"Layout_main__3y4Nb","content":"Layout_content__QwRCS"};